import { render } from "./TramitesPlaDetObs.vue?vue&type=template&id=5373a173&scoped=true"
import script from "./TramitesPlaDetObs.vue?vue&type=script&lang=js"
export * from "./TramitesPlaDetObs.vue?vue&type=script&lang=js"

import "./TramitesPlaDetObs.vue?vue&type=style&index=0&id=5373a173&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5373a173"]])

export default __exports__